import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { DeleteWidgetResponse } from './deleteWidget.types'

export const deleteWidget = async (widgetId: string) => {
  const response = await containerApi.delete<DeleteWidgetResponse>(
    `/desktop/widgets/${widgetId}`
  )
  return response.data
}

export const useDeleteWidgetMutation = (
  options?: ExtendableMutationOptions<DeleteWidgetResponse, string>
) => {
  return useMutation({
    mutationFn: deleteWidget,
    ...options
  })
}
